module.exports = __webpack_public_path__ + "static/media/employee.05f3e5c4.svg";